const profile = {
  moduleTitle: "Profile",
  nav: {
    account: "My account",
    profile: "Profile",
    security: "Security & privacy",
  },
  view: {
    subtitle: "Basic details and information about the profile",
    edit: "Edit",
    profileSection: "Profile",
    detailsSection: "Account details",
    company: "Company name",
    fullName: "Full name",
    email: "Email address",
    phoneNumber: "Phone number",
    username: "Username",
    lastPasswordChange: "Last password change",
    neverChanged: "Not changed yet",
    twoFactor: "Two-Factor Authentication (2FA)",
    loading: "Loading profile",
    error: "Couldn't load your profile.",
  },
  edit: {
    title: "Edit profile",
    subtitle: "Basic details and information about the profile",
    back: "Back",
    pictureSection: "Profile picture",
    upload: "Upload picture",
    remove: "Remove picture",
    pictureHint: "JPG, JPEG or PNG, max 20MB",
    invalidPicture:
      "Please upload a valid image (JPG, JPEG, or PNG) not exceeding the maximum allowed file size.",
    company: "Company name",
    nameAr: "Name (AR)",
    nameEn: "Name (EN)",
    username: "Username",
    email: "Email address",
    phoneNumber: "Phone number",
    countrySelectAriaLabel: "Select country code",
    countries: {
      ksa: "Saudi Arabia",
      egypt: "Egypt",
      uae: "United Arab Emirates",
      jordan: "Jordan",
    },
    cancel: "Cancel",
    save: "Save changes",
    saveSuccess: "Profile updated successfully.",
    removeDialog: {
      title: "Remove picture",
      message: "Are you sure you want to remove your profile picture?",
      confirm: "Remove",
      cancel: "Cancel",
      close: "Close",
    },
    unsavedChanges: {
      title: "Unsaved changes",
      message: "You have unsaved changes. Are you sure you want to leave?",
      stay: "Stay",
      leave: "Leave",
      close: "Close",
    },
  },
  twoFactor: {
    enableTitle: "Enable Two-Factor Authentication",
    description: "Enter the 6-digit verification code sent to {{email}}",
    codeLabel: "Verification code",
    codeRequired: "Enter the 6-digit verification code.",
    invalidCode: "Invalid verification code.",
    codeExpired: "The verification code has expired. Request a new one.",
    attemptsExceeded:
      "You have reached the maximum number of attempts. Please request a new verification code.",
    disableDialog: {
      title: "Disable Two-Factor Authentication",
      message: "Are you sure you want to disable Two-Factor Authentication?",
      note: "Disabling Two-Factor Authentication will lower your account's security, and your account will be protected by your password only.",
      confirm: "Disable",
      cancel: "Cancel",
      close: "Close",
    },
    confirm: "Confirm",
    verifying: "Verifying...",
    verified: "Verified successfully",
    close: "Close",
    expiresIn: "The code expires in",
    didNotReceive: "Didn't receive the code?",
    resend: "Resend code",
    resent: "A new code has been sent.",
    enabledSuccess: "Two-Factor Authentication has been enabled successfully.",
    disabledSuccess:
      "Two-Factor Authentication has been disabled successfully.",
  },
  security: {
    title: "Change password and security settings",
    subtitle: "Manage your password, security policies and active sessions",
    sectionTitle: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    currentPasswordRequired: "Current password is required.",
    save: "Save password",
    rulesTitle:
      "Your new password must meet the following criteria to protect your account:",
    success: "Your password has been changed successfully.",
    successSignedOut:
      "Your password has been changed successfully. Please sign in again.",
    incorrectCurrentPassword: "The current password is incorrect.",
    sameAsCurrent: "The new password must be different from the current one.",
  },
};

export default profile;
